module.exports = __webpack_public_path__ + "static/media/icon-training.b8de2a11.svg";